import React from "react";

const About = () => {
  return (
    <>
      <section className="about-hero">
        <div className="about-hero-card">
          <p className="typography2a about-hero-heading">About Us</p>
          <p className="typography3 about-hero-text">
            SILC is a membership based health service, geared towards the female
            weekend warrior, the high-performance athlete, and the stay-at-home
            entrepreneur
          </p>
        </div>
      </section>
      <section className="about-description">
        <p className="typography-descriptiom">
          <strong>
            Most entrepreneurs and corporate executive lead busy lives with
            limited time for selfcare,
          </strong>{" "}
          ignoring aches and pains, battling fatigue, low energy and weight gain
          as they juggle home, business and personal life.{" "}
          <strong>
            so we created a holistic treatment service that comes to you weekly,
            that’s individually tailored to your needs,
          </strong>{" "}
          attends to your aches and pains, provides relaxation, with a weight
          management solution -{" "}
          <strong>
            Which rejuvenate, reinvigorate and provide the vitality you need to
            continue your high value work and enjoy life,
          </strong>{" "}
          having better sleep, more clarity, increase productivity, look
          amazing, feeling healthy and strong, free from aches and pains{" "}
          <strong>
            enabling you to perform at your peak with confidence, while enjoying
            quality time with self and love ones.
          </strong>
        </p>
      </section>
      <section className="method-of-service">
        <h4 className="method-of-service-heading">
          This method of services has been ongoing since 2014 on a select basis.
          We serve three major demographics.{" "}
        </h4>
        <div className="method-of-service-card-wrapper">
          <div className="method-of-service-card">
            <div className="flex-vertical-end">
              <p className="typography-bold method-heading">Weekend warrior</p>
              <img src="./assets/method1.png" alt="method1" />
            </div>
            {/* <p className="body1">
              who leaves work on Friday, hits the links course or catches the
              next flight or road trip for an eventful weekend and returns
              injured.
            </p> */}
          </div>
          <div className="method-of-service-card">
            <div className="flex-vertical-end">
              <p className="typography-bold method-heading">Home Maker</p>
              <img src="./assets/method1.png" alt="method1" />
            </div>
            {/* <p className="body1">
              who leaves work on Friday, hits the links course or catches the
              next flight or road trip for an eventful weekend and returns
              injured.
            </p> */}
          </div>
          <div className="method-of-service-card">
            <div className="flex-vertical-end">
              <p className="typography-bold method-heading">
                Corporate Professional
              </p>
              <img src="./assets/method1.png" alt="method1" />
            </div>
            {/* <p className="body1">
              who leaves work on Friday, hits the links course or catches the
              next flight or road trip for an eventful weekend and returns
              injured.
            </p> */}
          </div>
        </div>
      </section>
      <section className="about-description">
        <p className="subtitle2">
          Over the years we have refined these high performance services to meet
          the demands of athletes and entrepreneurs by creating personalised and
          catered services with extended hours.
        </p>
        <p className="subtitle2 gap-between">
          The aim was to provide services that cater to individuals in a
          meaningful, responsible and purposeful manner, and were experiential
          in the privacy of their own homes or a safe space. Taking the clinic
          to the people was the better solution, while addresings the needs of
          individuals at a time and place, that was convenient for them.{" "}
        </p>
        <p className="subtitle2">
          Hence, SILC was rebranded to help people achieve their peak, mind and
          body performance through the power of connection. SILC, formerly
          Sports Injury London Clinic, was under pinned with a 3-tier care
          pathway - Awareness, Transition, Transformation.
        </p>
      </section>
      {/* <section className="appointment">
        <img src="./assets/AboutUsGuy1.png" alt="AboutUsGuy1" />
        <div className="appointment-wrapper">
          <p className="subtitle1">
            Richard’s work is global; he holds international and United Kingdom
            education credentials. In his early years, he worked in the banking
            sector in Toronto Canada and moonlighted in his second passion as a
            personal trainer on movie sets, before making a career transition to
            the medical profession and has spent many years within the National
            Health Service, private practice Harley Street in London and
            Military within a medical capacity. He will transfer all that
            experience and knowledge to you.
          </p>
          <div className="appointment-button-wrapper">
            <Button
              name="Richard Lorde, Founder, SILC"
              classNames="w-full sm:w-[275px] h-[32px]"
              background="transparent"
            />
            <Link to="/book">
              <Button
                name="Book Appointment Now"
                classNames="w-full sm:w-[410px] h-[48px] hover:bg-[#FFC53D]"
              />
            </Link>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default About;
